import {RouteObject} from 'react-router-dom';

import PiuLayout from '@modules/piu/layout/PiuLayout';
import DatatableStoreProvider from '@common/stores/DatatableStoreProvider';
import CompositionSheetLayout from '@modules/piu/features/compositionSheet/layout/CompositionSheetLayout';

const piuRoutes: RouteObject[] = [
  {
    path: 'compositions',
    element: <PiuLayout />,
    children: [
      {
        index: true,
        async lazy() {
          const {default: CompositionsDashboard} = await import('@modules/piu/pages/CompositionsDashboard');

          return {
            element: (
              <DatatableStoreProvider>
                <CompositionsDashboard />
              </DatatableStoreProvider>
            )
          };
        }
      }
    ]
  },
  {
    path: 'products',
    element: <PiuLayout />,
    children: [
      {
        index: true,
        async lazy() {
          const {default: ProductsDashboard} = await import('@modules/piu/pages/ProductsDashboard');

          return {
            element: (
              <DatatableStoreProvider>
                <ProductsDashboard />
              </DatatableStoreProvider>
            )
          };
        }
      }
    ]
  },
  {
    path: 'skus',
    element: <PiuLayout />,
    children: [
      {
        index: true,
        async lazy() {
          const {default: SkusDashboard} = await import('@modules/piu/pages/SkusDashboard');

          return {
            element: (
              <DatatableStoreProvider>
                <SkusDashboard />
              </DatatableStoreProvider>
            )
          };
        }
      }
    ]
  },
  {
    path: 'product-sheet',
    element: <PiuLayout />,
    children: [
      {
        path: ':productId',
        async lazy() {
          const {default: ProductLayout} = await import('@modules/piu/layout/ProductLayout');

          return {Component: ProductLayout};
        },
        children: [
          {
            index: true,
            async lazy() {
              const {default: ProductSheet} = await import('@modules/piu/features/productSheet/pages/ProductSheet');

              return {Component: ProductSheet};
            }
          },
          {
            path: 'translations',
            async lazy() {
              const {default: Translations} = await import('@modules/piu/features/productSheet/pages/Translations');

              return {Component: Translations};
            }
          }
        ]
      }
    ]
  },
  {
    path: 'composition-sheet',
    element: <CompositionSheetLayout />,
    children: [
      {
        path: ':compositionId',
        async lazy() {
          const {default: CompositionSheet} = await import('@modules/piu/features/compositionSheet/pages/CompositionSheet');

          return {Component: CompositionSheet};
        }
      }
    ]
  }
];

export default piuRoutes;
